<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <div class="header-content">
      {{ 'DOORS.EDIT_MODAL.TITLE' | translate }}
    </div>
    <span class="ui-icon-close c-p" (click)="close()"></span>
  </div>

  <div class="body">
    <div class="form-field">
      <label class="form-label">{{ 'DOORS.TABLE.NAME' | translate }}</label>
      <input
        type="text"
        class="ui-input"
        [(ngModel)]="editableDoor().name"
      />
    </div>
  </div>

  <div class="footer">
    <ui-button
      type="secondary"
      [text]="'COMMON.CANCEL' | translate"
      (clickAction)="onCancel()"
    ></ui-button>
    <ui-button
      type="primary"
      [text]="'COMMON.SAVE' | translate"
      (clickAction)="onSave()"
    ></ui-button>
  </div>
</div>
